"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DXSystemColors = void 0;
var color_1 = require("@devexpress/utils/lib/utils/color");
var DXSystemColors = (function () {
    function DXSystemColors() {
    }
    DXSystemColors.control = color_1.ColorUtils.fromArgbNumber(255, 240, 240, 240);
    DXSystemColors.controlDark = color_1.ColorUtils.fromArgbNumber(255, 160, 160, 160);
    DXSystemColors.window = color_1.ColorUtils.fromArgbNumber(255, 255, 255, 255);
    DXSystemColors.activeBorder = color_1.ColorUtils.fromArgbNumber(255, 180, 180, 180);
    DXSystemColors.activeCaption = color_1.ColorUtils.fromArgbNumber(255, 153, 180, 209);
    DXSystemColors.activeCaptionText = color_1.ColorUtils.fromArgbNumber(255, 0, 0, 0);
    DXSystemColors.appWorkspace = color_1.ColorUtils.fromArgbNumber(255, 171, 171, 171);
    DXSystemColors.controlDarkDark = color_1.ColorUtils.fromArgbNumber(255, 105, 105, 105);
    DXSystemColors.controlLight = color_1.ColorUtils.fromArgbNumber(255, 227, 227, 227);
    DXSystemColors.controlLightLight = color_1.ColorUtils.fromArgbNumber(255, 255, 255, 255);
    DXSystemColors.controlText = color_1.ColorUtils.fromArgbNumber(255, 0, 0, 0);
    DXSystemColors.desktop = color_1.ColorUtils.fromArgbNumber(255, 0, 0, 0);
    DXSystemColors.grayText = color_1.ColorUtils.fromArgbNumber(255, 109, 109, 109);
    DXSystemColors.highlight = color_1.ColorUtils.fromArgbNumber(255, 0, 120, 215);
    DXSystemColors.highlightText = color_1.ColorUtils.fromArgbNumber(255, 255, 255, 255);
    DXSystemColors.hotTrack = color_1.ColorUtils.fromArgbNumber(255, 0, 102, 204);
    DXSystemColors.inactiveBorder = color_1.ColorUtils.fromArgbNumber(255, 244, 247, 252);
    DXSystemColors.inactiveCaption = color_1.ColorUtils.fromArgbNumber(255, 191, 205, 219);
    DXSystemColors.inactiveCaptionText = color_1.ColorUtils.fromArgbNumber(255, 0, 0, 0);
    DXSystemColors.info = color_1.ColorUtils.fromArgbNumber(255, 255, 255, 225);
    DXSystemColors.infoText = color_1.ColorUtils.fromArgbNumber(255, 0, 0, 0);
    DXSystemColors.menu = color_1.ColorUtils.fromArgbNumber(255, 240, 240, 240);
    DXSystemColors.menuText = color_1.ColorUtils.fromArgbNumber(255, 0, 0, 0);
    DXSystemColors.scrollBar = color_1.ColorUtils.fromArgbNumber(255, 200, 200, 200);
    DXSystemColors.windowFrame = color_1.ColorUtils.fromArgbNumber(255, 100, 100, 100);
    DXSystemColors.windowText = color_1.ColorUtils.fromArgbNumber(255, 0, 0, 0);
    DXSystemColors.gradientActiveCaption = color_1.ColorUtils.fromArgbNumber(255, 185, 209, 234);
    DXSystemColors.gradientInactiveCaption = color_1.ColorUtils.fromArgbNumber(255, 215, 228, 242);
    DXSystemColors.menuBar = color_1.ColorUtils.fromArgbNumber(255, 240, 240, 240);
    DXSystemColors.menuHighlight = color_1.ColorUtils.fromArgbNumber(255, 51, 153, 255);
    return DXSystemColors;
}());
exports.DXSystemColors = DXSystemColors;
